<script setup lang="ts">
import { OnClickOutside } from "@vueuse/components";
import { LANGUAGES } from "core/constants";
import { LOCALE } from "core/interfaces";
import { useModal } from "shared/composables";

const { locale: currentLocale, setLocale } = useI18n();
const { closeModal, toggleModal, isModalOpened } = useModal();

const setLocaleAndCloseMenu = async (locale: LOCALE) => {
	closeModal();
	await setLocale(locale);
};

const currentLanguage = computed(() => LANGUAGES.find(language => language.locale === currentLocale.value));
</script>

<template>
	<OnClickOutside @trigger="closeModal">
		<div class="group relative text-green-dark text-sm">
			<button class="flex items-center gap-x-2 group-hover:text-black" @click="toggleModal">
				<span>{{ currentLanguage?.name }}</span>
				<Icon
					class="duration-150"
					:class="isModalOpened && 'rotate-180'"
					name="solar:alt-arrow-up-outline"
					size="16"
				/>
			</button>
			<ul
				v-show="isModalOpened"
				class="absolute bottom-6 left-1/2 -translate-x-1/2 bg-white border border-gray p-1 rounded-xs"
			>
				<li
					v-for="({id, locale, name}) in LANGUAGES"
					:key="id"
				>
					<button
						class="py-1 px-3 hover:underline"
						@click="setLocaleAndCloseMenu(locale)"
					>
						{{ name }}
					</button>
				</li>
			</ul>
		</div>
	</OnClickOutside>
</template>
